import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { acceptKnowledgeSuggestion } from "./schema/accept-knowledge-suggestion";
import { createKnowledgeArticle } from "./schema/create-knowledge-article";
import { createProductKnowledge } from "./schema/create-product-knowledge";
import { getDemoKnowledgeArticle } from "./schema/get-demo-knowledge-article";
import { getKnowledgeArticle } from "./schema/get-knowledge-article";
import { getKnowledgeArticles } from "./schema/get-knowledge-articles";
import { getKnowledgeCounts } from "./schema/get-knowledge-counts";
import { getKnowledgeItem } from "./schema/get-knowledge-item";
import { getKnowledgeSuggestions } from "./schema/get-knowledge-suggestions";
import { getProductKnowledge } from "./schema/get-product-knowledge";
import { getSuggestionSources } from "./schema/get-suggestion-sources";
import { importKnowledgeCsv } from "./schema/import-knowledge-csv";
import { linkFaqKnowledge } from "./schema/link-faq-knowledge";
import { listKnowledge } from "./schema/list-knowledge";
import { listProductKnowledge } from "./schema/list-product-knowledge";
import { listProductMetafieldDefinitions } from "./schema/list-product-metafield-definitions";
import { listSuggestedKnowledge } from "./schema/list-suggested-knowledge";
import { rejectKnowledgeSuggestion } from "./schema/reject-knowledge-suggestion";
import { removeKnowledge } from "./schema/remove-knowledge";
import { removeProductKnowledge } from "./schema/remove-product-knowledge";
import { scrapeKnowledge } from "./schema/scrape-knowledge";
import { searchKnowledgeProductFamilies } from "./schema/search-knowledge-product-families";
import { setKnowledgeAvailability } from "./schema/set-knowledge-availability";
import { setProductKnowledgeStatus } from "./schema/set-product-knowledge-status";
import { updateKnowledgeArticle } from "./schema/update-knowledge-article";
import { updateProductKnowledge } from "./schema/update-product-knowledge";
import { upsertDemoKnowledgeArticle } from "./schema/upsert-demo-knowledge-article";

export const rpcDefinition = {
  listKnowledge,
  listSuggestedKnowledge,
  getKnowledgeCounts,
  getSuggestionSources,
  getKnowledgeArticle,
  getKnowledgeArticles,
  getKnowledgeItem,
  getKnowledgeSuggestions,
  createKnowledgeArticle,
  importKnowledgeCsv,
  updateKnowledgeArticle,
  setKnowledgeAvailability,
  removeKnowledge,
  linkFaqKnowledge,
  acceptKnowledgeSuggestion,
  rejectKnowledgeSuggestion,
  scrapeKnowledge,
  searchKnowledgeProductFamilies,
  getDemoKnowledgeArticle,
  upsertDemoKnowledgeArticle,
  listProductKnowledge,
  getProductKnowledge,
  createProductKnowledge,
  updateProductKnowledge,
  setProductKnowledgeStatus,
  removeProductKnowledge,
  listProductMetafieldDefinitions,
};

export type RedoMerchantAgentKnowledgeRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
